function findLastOccurrenceToken(startContainer) {
  let container = startContainer

  while (container) {
    const tokens = container.getElementsByClassName('occ')
    if (tokens.length > 0) return tokens[tokens.length - 1]
    container = container.previousElementSibling
  }

  return null
}

export { findLastOccurrenceToken }
